import { UntypedFormGroup } from '@angular/forms';

export const TRACKABLE_EVENTS_AUTH = {
  // auth
  visitSignUp: () => ['sign up visit'],
  createAccountClicked: (payload: { email: string }) => ['create account clicked', payload],
  confirmEmail: (payload: { email: string }) => ['email confirmed', payload],
  visitLogin: () => ['login visit']
};

export enum ClientSubscriptionTypes {
  facebookCommerce = 'facebook_commerce',
  facebookCreative = 'facebook_creative',
  facebookStatistics = 'facebook_statistics',
  googleCreative = 'google_creative',
  tiktokCreative = 'tiktok_creative',
  videoDownload = 'video_download',
  hideUpload = 'facebook_creative_hide_upload',
  withAspectRatio = 'overlay_editor_change_format',
  hypersonaplizationAllowed = 'overlay_h13n',
  multiCountryAllowed = 'multi_country_overlay_edit',
  taggedOverlay = 'tagged_overlay',
  convertToSpeech = 'convert_to_speech',
  videoTemplateUpload = 'video_template_upload',
  facebookVideoFeed = 'facebook_video_feed',
  facebookVideoFeedTemplateApplyUnlimit = 'facebook_video_feed_template_apply_unlimit'
}

export const USERNAME_MAX_LENGTH = 180;
export const PASSWORD_MAX_LENGTH = 255;

export const MISSING_REFRESH_TOKEN_ERROR = 'MISSING REFRESH TOKEN';

// custom validator to check that two fields match
// eslint-disable-next-line @typescript-eslint/naming-convention
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
